import {
  FacilityOrderBagStatuses,
  FacilityServiceShortCodes,
} from '@/helpers/enums';

const keyboardKeyNames = {
  delete: ['Backspace', 'Delete', 'Del'],
};

const historyOrdersPerPage = 10;

// Used for confirm button to show saving check when there is no actual api
const mockSavingDataTime = 300;

const defaultNotificationDuration = 5000;

const descriptionMinLength = 5;

const maxRequiredBlurryPhotoRetries = 3;

export const ClarityMainEventName = `Station app: ${import.meta.env.VITE_ENV}`;

export const washServices: FacilityServiceShortCodes[] = [
  FacilityServiceShortCodes.wash,
  FacilityServiceShortCodes.separate_wash,
  FacilityServiceShortCodes.mixed_wash,
];

export const ironingServices: FacilityServiceShortCodes[] = [
  FacilityServiceShortCodes.iron_only,
  FacilityServiceShortCodes.ironing_only,
  FacilityServiceShortCodes.ironing,
];

export const bulkyServices: FacilityServiceShortCodes[] = [
  FacilityServiceShortCodes.duvets_bulky_items,
  FacilityServiceShortCodes.duvets_and_bulky_items,
];

export const notItemisedStatuses: FacilityOrderBagStatuses[] = [
  FacilityOrderBagStatuses.scanned,
  FacilityOrderBagStatuses.to_scan,
];

export const notReadyToPackStatuses: FacilityOrderBagStatuses[] = [
  FacilityOrderBagStatuses.to_scan,
  FacilityOrderBagStatuses.scanned,
  FacilityOrderBagStatuses.on_hold,
];

export const LHMobileAppUrl = 'https://l.sng.link/Djy1g/84t7/4bzd';

export default {
  keyboardKeyNames,
  mockSavingDataTime,
  ClarityMainEventName,
  historyOrdersPerPage,
  defaultNotificationDuration,
  washServices,
  descriptionMinLength,
  maxRequiredBlurryPhotoRetries,
};
